var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
var SvgPacketLossIcon = function SvgPacketLossIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 14",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.82 6.732 16.705.103A.4.4 0 0 0 16.451 0a.38.38 0 0 0-.256.103l-.86.804a.36.36 0 0 0-.118.262c0 .097.043.194.118.261L21.307 7l-5.972 5.57a.36.36 0 0 0-.118.261c0 .098.043.195.118.262l.86.804a.37.37 0 0 0 .511 0l7.12-6.635A.36.36 0 0 0 23.943 7a.4.4 0 0 0-.125-.268zM2.636 7l5.972-5.57a.36.36 0 0 0 .118-.261.36.36 0 0 0-.118-.262l-.86-.804A.4.4 0 0 0 7.493 0a.38.38 0 0 0-.256.103L.118 6.738A.36.36 0 0 0 0 7a.36.36 0 0 0 .118.262l7.12 6.635a.4.4 0 0 0 .255.103.37.37 0 0 0 .256-.103l.86-.804a.36.36 0 0 0 .118-.262.36.36 0 0 0-.118-.261L2.637 7z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 2.4,
    x: 6.8,
    y: 5.8,
    rx: 0.5,
    transform: "rotate(45 8 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 2.4,
    x: 14.8,
    y: 5.8,
    rx: 0.5,
    transform: "rotate(45 16 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.4,
    height: 2.4,
    x: 10.8,
    y: 5.8,
    rx: 0.5,
    transform: "rotate(45 12 7)"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPacketLossIcon);
var Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;